export default __webpack_public_path__ + "static/cardImg2-5b8b87c091690ad22f21028275b5cc6a.webp";